import { ServiceStatus } from '@editor/interfaces/servicestatus'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface SystemState {
  serviceStatus: ServiceStatus | null
}

const initialState: SystemState = {
  serviceStatus: null,
}

export const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setServiceStatus: (state, action: PayloadAction<ServiceStatus>) => {
      state.serviceStatus = action.payload
    },
  },
})

export const { setServiceStatus } = systemSlice.actions

export default systemSlice.reducer
